$(document).ready(function () {
    let opportunitiesSlider = new Swiper("#ourOpportunitiesHome", {
        slidesPerView: 1,
        speed: 1000,
        autoplay: {
            delay: 9000,
        },
        pagination: {
            el: "#ourOpportunitiesHome .swiper-pagination",
            clickable: true,
        },
    });

    let timer;
    $(window).scroll(function () {
        if (timer) {
            window.clearTimeout(timer);
        }
        timer = window.setTimeout(function () {
            let sliderElement = document.getElementById('ourOpportunitiesHome');
            if (elementIsVisibleInViewport(sliderElement, 300, true)) {
                opportunitiesSlider.autoplay.start();
                window.clearTimeout(timer);
            } else {
                opportunitiesSlider.autoplay.stop();
                window.clearTimeout(timer);
            }
        }, 100);
    });

    const elementIsVisibleInViewport = (el, gap = 0, partiallyVisible = false) => {
        let {top, left, bottom, right} = el.getBoundingClientRect();
        top += gap;
        const {innerHeight, innerWidth} = window;
        return partiallyVisible
            ? ((top > 0 && top < innerHeight) ||
                (bottom > 0 && bottom < innerHeight)) &&
            ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
            : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
    };

});
